import { useEffect } from 'react';

import { signOutAfterWorkspaceDeletion } from './use-workspace-deletion';

/** Long enough for the mark to finish and the copy to be read. */
export const DELETION_REDIRECT_DELAY_MS = 3500;

/** Full-screen confirmation, the booking "confirmed" mark in destructive red.
 * Decorative motion only; the CSS honours reduced motion. */
export function DeletionRequestedScreen() {
  useEffect(() => {
    const timer = window.setTimeout(() => {
      void signOutAfterWorkspaceDeletion();
    }, DELETION_REDIRECT_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, []);
  return (
    <div
      role="status"
      aria-live="polite"
      className="deletion-confirmation fixed inset-0 z-50 flex flex-col items-center justify-center bg-background px-4 py-12 text-center"
    >
      <div className="deletion-confirmation-mark" aria-hidden="true">
        <div className="deletion-confirmation-halo" />
        <div className="deletion-confirmation-ring" />
        <div className="deletion-confirmation-disc">
          <svg
            aria-hidden="true"
            viewBox="0 0 48 48"
            fill="none"
            className="size-12"
          >
            <path
              className="deletion-confirmation-tick"
              d="m12 24 8 8 16-16"
              stroke="currentColor"
              strokeWidth="3.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              pathLength="1"
            />
          </svg>
        </div>
        <span className="deletion-confirmation-spark deletion-confirmation-spark-one" />
        <span className="deletion-confirmation-spark deletion-confirmation-spark-two" />
        <span className="deletion-confirmation-spark deletion-confirmation-spark-three" />
        <span className="deletion-confirmation-spark deletion-confirmation-spark-four" />
      </div>
      <h1 className="mt-6 font-semibold text-3xl text-foreground md:text-4xl">
        Account deletion request successful
      </h1>
      <p className="mt-2 max-w-md text-muted-foreground">
        Your data will be removed in 30 days or less.
      </p>
      <p className="mt-6 text-sm text-muted-foreground">
        Redirecting back to sign in…
      </p>
    </div>
  );
}
